export default class HomeEnum {
    static SLIDER_BANNER = '[data-id="home-banner-slider"]'
    static SLIDER_BANNER_WRAPPER = '[data-id="home-banner-slider-wrapper"]'
    static SLIDER_BANNER_ITEM = '[data-id="home-banner-slider-item"]'
    // static SLIDER_BANNER_PAGINATION = '#home-banner-slider-pagination';

    static SLIDER_TRAVEL = '[data-id="home-travel-slider"]'
    static SLIDER_TRAVEL_WRAPPER = '[data-id="home-travel-slider-wrapper"]'
    static SLIDER_TRAVEL_ITEM = '[data-id="home-travel-slider-item"]'
    static SLIDER_TRAVEL_PAGINATION = '#home-travel-slider-pagination'
    static SLIDER_TRAVEL_ANCHORS = '[data-element="home-travel-anchors"]'
    static SLIDER_TRAVEL_ANCHOR = '[data-element="home-travel-anchor"]'

    static WRAPPER_BLOG = '[data-element="home-blog-items-wrapper"]'
    static SLIDER_BLOG = '[data-id="home-blog-slider"]'
    static SLIDER_BLOG_WRAPPER = '[data-id="home-blog-slider-wrapper"]'
    static SLIDER_BLOG_ITEM = '[data-id="home-blog-slider-item"]'
    static SLIDER_BLOG_PAGINATION = '#home-blog-slider-pagination'
    static SLIDER_BLOG_ANCHORS = '[data-element="home-blog-anchors"]'
    static SLIDER_BLOG_ANCHOR = '[data-element="home-blog-anchor"]'

    static SLIDER_ESCAPE = '[data-id="home-escape-slider"]'
    static SLIDER_ESCAPE_WRAPPER = '[data-id="home-escape-slider-wrapper"]'
    static SLIDER_ESCAPE_ITEM = '[data-id="home-escape-slider-item"]'
    static SLIDER_ESCAPE_PAGINATION = '#home-escape-slider-pagination'

    static SLIDER_AGENDA = '[data-id="home-agenda-slider"]'
    static SLIDER_AGENDA_WRAPPER = '[data-id="home-agenda-slider-wrapper"]'
    static SLIDER_AGENDA_ITEM = '[data-id="home-agenda-slider-item"]'
    static SLIDER_AGENDA_PAGINATION = '#home-agenda-slider-pagination'

    static PARALLAX_ITEM = '[data-animation="parallax"]'
}
